<template>
  <div>
    <header
      :class="isVisible?'header-navigation slideDown':'header-navigation slideUp'"
      id="header"
    >
      <nav>
        <div class="logo">
          <router-link to="/">
            <el-image
              v-if="info.logoPhoto"
              style="height: 35px; vertical-align: middle;"
              :src="info.logoPhoto"
              fit="contain">
            </el-image>
          </router-link>
        </div>

        <h2 id="mnavh" @click="openHead" :class="showHead?'open':''">
          <span class="navicon"></span>
        </h2>

        <ul id="starlist" :style="showHead?'display: block':''">

          <li v-for="webNavbar in webNavbarList" :key="webNavbar.uid">

            <!--判断是否有下拉菜单-->
            <span v-if="webNavbar.childWebNavbar && webNavbar.childWebNavbar.length > 0">
              <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                {{ webNavbar.name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :key="index" v-for="(childWebNavbar, index)  in webNavbar.childWebNavbar">
                  <router-link v-if="childWebNavbar.isJumpExternalUrl == 0" :to="childWebNavbar.url" @click.native="openHead">
                    {{ childWebNavbar.name }}
                  </router-link>
                  <a v-if="childWebNavbar.isJumpExternalUrl == 1" :href="childWebNavbar.url"
                     target="_blank">{{ childWebNavbar.name }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            </span>
            <!--没有有下拉菜单-->
            <span v-else>
              <router-link v-if="webNavbar.isJumpExternalUrl == 0" :to="webNavbar.url" :class="[saveTitle == webNavbar.url ? 'title' : '']"
                           @click.native="openHead">
                {{ webNavbar.name }}
              </router-link>
              <a v-if="webNavbar.isJumpExternalUrl == 1" :href="webNavbar.url" target="_blank"
                 :class="[saveTitle == webNavbar.url ? 'title' : '']">
                {{ webNavbar.name }}
              </a>
            </span>
          </li>

        </ul>

        <div class="searchbox">
          <div id="search_bar" :class="(showSearch || keyword.length > 0)?'search_bar search_open':'search_bar'">
            <input
              ref="searchInput"
              class="input"
              placeholder="想搜点什么呢.."
              type="text"
              name="keyboard"
              v-model="keyword"
              v-on:keyup.enter="search"
            >
            <p class="search_ico" @click="clickSearchIco" :style="(browserFlag == 1)?'':'top:17px'">
              <span></span>
            </p>
          </div>
        </div>

        <el-dropdown @command="handleCommand" class="userInfoAvatar">

          <span class="el-dropdown-link">
            <el-badge :value="enrollMsg" class="item" :hidden="!isLogin || userEnrollCount == 0">
              <img v-if="!isLogin" src="../../static/images/defaultAvatar.png">
              <img v-if="isLogin&&userInfo.photoUrl!=undefined" :src="userInfo.photoUrl"
                   onerror="onerror=null;src=defaultAvatar">
              <img v-if="isLogin&&userInfo.photoUrl==undefined"
                   :src="defaultAvatar">
            </el-badge>
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="login" v-show="!isLogin">登录/注册</el-dropdown-item>
            <el-dropdown-item v-show="isLogin" style="color: #409eff;">{{userInfo.username}}</el-dropdown-item>
            <el-dropdown-item divided command="goUserInfo" v-show="isLogin">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout" v-show="isLogin">退出登录</el-dropdown-item>
          </el-dropdown-menu>

        </el-dropdown>


      </nav>
    </header>

    <LoginBox v-if="showLogin==1" @closeLoginBox="closeLoginBox"></LoginBox>

    <el-drawer
      :show-close="true"
      :visible.sync="drawer"
      :size="drawerSize"
      :with-header="false">

      <el-tabs type="border-card" tab-position="left" v-model="activeName" style="margin-top: 50px; height: 100%;"
               @tab-click="handleClick">
        <el-tab-pane label="个人中心" name="0">
          <span slot="label"><i class="el-icon-user-solid"></i> 个人中心</span>
          <el-form label-position="left" :model="userInfo" label-width="100px" :rules="rules" ref="userInfo">
            <el-form-item label="用户头像" :label-width="labelWidth">

              <div class="imgBody" v-if="userInfo.photoUrl">
                <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('user')"
                   @mouseover="icon = true"></i>
                <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="userInfo.photoUrl"/>
              </div>

              <div v-else class="uploadImgBody" @click="checkPhoto">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-form-item>

            <el-form-item label="用户名" :label-width="labelWidth">
              <el-input v-model="userInfo.username" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="性别" :label-width="labelWidth">
              <el-radio v-for="gender in genderDictList" :key="gender.uid" v-model="userInfo.gender"
                        :label="parseInt(gender.dictValue)" border size="medium">{{ gender.dictLabel }}
              </el-radio>
            </el-form-item>

            <el-form-item label="生日" :label-width="labelWidth">
              <el-date-picker
                v-model="userInfo.birthday"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="反馈邮件通知" :label-width="labelWidth">
              <el-radio v-for="item in yesNoDictList" :key="item.uid" v-model="userInfo.emailNotification"
                        :label="parseInt(item.dictValue)" border size="medium">{{ item.dictLabel }}
              </el-radio>
            </el-form-item>

            <el-form-item label="手机号码" :label-width="labelWidth" prop="mobile">
              <el-input :disabled="true" v-model="userInfo.mobile" style="width: 80%"></el-input><el-link icon="el-icon-edit" type="primary" :underline="false" @click.prevent="changeMobile()">修改</el-link>
            </el-form-item>

            <el-form-item label="邮箱" :label-width="labelWidth" prop="email">
              <el-input :disabled="true" v-model="userInfo.email" style="width: 80%"></el-input><el-link icon="el-icon-edit" type="primary" :underline="false" @click.prevent="changeEmail()">修改</el-link>
            </el-form-item>

            <el-form-item label="职业" :label-width="labelWidth" prop="occupation">
              <el-input v-model="userInfo.occupation" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="简介" :label-width="labelWidth" prop="summary">
              <el-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10}"
                placeholder="请输入内容"
                style="width: 100%"
                v-model="userInfo.summary">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('editUser')">保 存</el-button>
            </el-form-item>

          </el-form>
        </el-tab-pane>

        <el-tab-pane label="我的报名" name="1">
          <span slot="label"><i class="el-icon-star-on"></i> 我的报名</span>
          <div style="width: 100%; height: 840px;overflow:auto">
            <el-table :data="enrollList" style="width: 100%" tooltip-effect="light">
              <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>

              <el-table-column label="订单号" width="145" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="showDetails(scope.row.orderNo)">{{ scope.row.orderNo }}</span>
                </template>
              </el-table-column>

              <el-table-column label="赛事" width="135" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.goodsName }}</span>
                </template>
              </el-table-column>

              <el-table-column label="金额" width="75" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.totalAmount | formatPrice }}</span>
                </template>
              </el-table-column>

              <el-table-column label="状态" width="65" align="center">
                <template slot-scope="scope">
                  <span :key="pay.uid" v-for="pay in payStatusDictList" v-if="scope.row.payStatus == pay.dictValue">
                    {{ pay.dictLabel }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="操作" fixed="right" min-width="150">
                <template slot-scope="scope">
                  <!-- 订单状态:0未付款,1已付款,3已完成,4已取消,5退款中,6已延赛 -->
                  <el-button @click="goToPayment(scope.row.orderNo)" type="primary" v-if="scope.row.payStatus == 0" size="small">支付</el-button>
                  <el-button @click="cancelOrder(scope.row.orderNo)" type="info" v-if="scope.row.payStatus == 0" size="small">取消</el-button>
                  <el-button @click="delOrder(scope.row.orderNo)" type="danger" v-if="scope.row.payStatus == 4" size="small">删除</el-button>
                  <el-button @click="showDetails(scope.row.orderNo)" type="primary" v-if="scope.row.payStatus != 0 && scope.row.payStatus != 4" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 50, 100, 200]"
                :page-size="pageSize"
                layout="sizes, total, prev, pager, next"
                :total="total"
              ></el-pagination>
            </div>

            <!--<el-timeline>
              <el-timeline-item v-for="enroll in enrollList" :key="enroll.id" :timestamp="timeAgo(enroll.createdTime)"
                placement="top">
                <el-card shadow="hover" style="cursor: pointer; color: green;" @click.native="goToInfo(enroll.articleId)">
                  <span style="font-weight: bold; text-decoration: underline">{{ enroll.raceTitle }}</span>
                  <div>报名费用：{{formatPrice(enroll.price)}}</div>
                  <div>缴费时间：{{enroll.updatedTime}}</div>
                </el-card>
              </el-timeline-item>

              <el-timeline-item v-if="enrollList.length == 0" placement="top">
                <el-card>
                  <span style="font-size: 16px">空空如也~</span>
                </el-card>
              </el-timeline-item>
            </el-timeline>-->
          </div>
        </el-tab-pane>

        <el-tab-pane label="我的售后" name="2">
          <span slot="label"><i class="el-icon-s-finance"></i> 我的售后</span>

          <el-collapse v-model="activeNames">
            <el-collapse-item title="延赛退赛须知" name="1">
              <div>延赛、退赛申请提交后，我们将根据<a href="https://www.ganjiangyou.cn/terms" target="_blank" style="color: #ff5722; text-decoration: underline;">购买条款</a>进行后续操作</div>
            </el-collapse-item>
          </el-collapse>
          <el-divider></el-divider>

          <div style="width: 100%; height: 650px;overflow:auto">
            <el-timeline>
              <el-timeline-item v-for="afterSalesItem in afterSalesList" :key="afterSalesItem.id"
                                :timestamp="timeAgo(afterSalesItem.createdTime)" placement="top">
                <el-card class="afterSalesCard">
                  <div class="item">
                    <span class="title">
                      赛事:
                    </span>
                    <span class="content">
                      {{ afterSalesItem.raceTitle }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      订单号:
                    </span>
                    <span class="order" @click="showDetails(afterSalesItem.orderNo)">
                      {{ afterSalesItem.orderNo }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      申请类型:
                    </span>
                    <span class="content" v-if="afterSalesItem.type == 1">
                      保留参赛资格至下一年
                    </span>
                    <span class="content" v-if="afterSalesItem.type == 2">
                      退赛退款
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      审核状态:
                    </span>
                    <span class="content">
                      <el-tag v-for="item in afterSalesDictList" :key="item.uid" :type="item.listClass"
                              v-if="afterSalesItem.status == item.dictValue">{{ item.dictLabel }}</el-tag>
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      回复:
                    </span>
                    <span class="content">
                      {{ afterSalesItem.reply }}
                    </span>
                  </div>
                </el-card>
              </el-timeline-item>

              <el-timeline-item v-if="afterSalesList.length == 0" placement="top">
                <el-card>
                  <span style="font-size: 16px">空空如也~</span>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>

        <el-tab-pane label="我的成绩" name="3">
          <span slot="label"><i class="el-icon-trophy"></i> 我的成绩</span>
          <div style="width: 100%; height: 840px;overflow:auto">
            <el-table :data="resultList" style="width: 100%" tooltip-effect="light">
              <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>

              <el-table-column label="赛事" width="160" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.raceTitle }}</span>
                </template>
              </el-table-column>

              <el-table-column label="姓名" width="80" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.username }}</span>
                </template>
              </el-table-column>

              <el-table-column label="参赛号码" width="80" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.raceNumber }}</span>
                </template>
              </el-table-column>

              <el-table-column label="比赛用时" width="130" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.resultTime}}</span>
                </template>
              </el-table-column>

              <el-table-column label="证书" fixed="right" min-width="50">
                <template slot-scope="scope">
                  <el-button @click="downloadCertificate(scope.row.id)" type="primary" size="small">下载</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!--分页-->
            <div class="block">
              <el-pagination
                @current-change="handleCurrentChangeTwo"
                :current-page.sync="currentPageTwo"
                :page-size="pageSizeTwo"
                layout="total, prev, pager, next, jumper"
                :total="totalTwo"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="我的反馈" name="4">
          <span slot="label"><i class="el-icon-phone"></i> 我的反馈</span>

          <el-collapse v-model="activeNames">
            <el-collapse-item title="反馈须知" name="1">
              <div>如果您对本站有什么想法，可以在这里进行反馈</div>
            </el-collapse-item>
          </el-collapse>
          <el-divider></el-divider>

          <div style="width: 100%; height: 450px;overflow:auto">
            <el-timeline>
              <el-timeline-item v-for="feedbackItem in feedbackList" :key="feedbackItem.uid"
                                :timestamp="timeAgo(feedbackItem.createTime)" placement="top">
                <el-card class="feedbackCard">
                  <div class="item">
                    <span class="title">
                      标题:
                    </span>
                    <span class="content">
                      {{ feedbackItem.title }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      内容:
                    </span>
                    <span class="content">
                      {{ feedbackItem.content }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      反馈状态:
                    </span>
                    <span class="content">
                      <el-tag v-for="item in feedbackDictList" :key="item.uid" :type="item.listClass"
                              v-if="feedbackItem.feedbackStatus == item.dictValue">{{ item.dictLabel }}</el-tag>
                    </span>
                  </div>

                  <div class="item">
                    <span class="title">
                      回复:
                    </span>
                    <span class="content">
                      {{ feedbackItem.reply }}
                    </span>
                  </div>
                </el-card>
              </el-timeline-item>

              <el-timeline-item v-if="feedbackList.length == 0" placement="top">
                <el-card>
                  <span style="font-size: 16px">空空如也~</span>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>

          <el-divider></el-divider>

          <el-form ref="feedback" label-position="left" :model="feedback" label-width="100px" :rules="feedbackRules">
            <el-form-item label="标题" :label-width="labelWidth" prop="title">
              <el-input placeholder="请输入标题" v-model="feedback.title" clearable style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="内容" :label-width="labelWidth" prop="content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入反馈内容"
                v-model="feedback.content"
                clearable>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('feedback')">提 交</el-button>
            </el-form-item>
          </el-form>

        </el-tab-pane>

        <el-tab-pane label="修改密码" name="5">
          <span slot="label"><i class="el-icon-s-tools"></i> 修改密码</span>
          <el-collapse v-model="activeNames">
            <el-collapse-item title="修改密码须知" name="1">
              <div>第三方登录的账号初始密码：ganjiangyou2024</div>
            </el-collapse-item>
          </el-collapse>
          <el-form ref="userInfoForm" label-position="left" :model="userInfo" label-width="100px"
                   :rules="userInfoRules">
            <el-form-item label="旧密码" :label-width="labelWidth" prop="oldPwd">
              <el-input type="password" v-model="userInfo.oldPwd" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="新密码" :label-width="labelWidth" prop="newPwd">
              <el-input type="password" v-model="userInfo.newPwd" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="重复密码" :label-width="labelWidth" prop="newPwd2">
              <el-input type="password" v-model="userInfo.newPwd2" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('changePwd')">提 交</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

      </el-tabs>
    </el-drawer>

    <!--头像裁剪-->
    <avatar-cropper
      v-show="imagecropperShow"
      :key="imagecropperKey"
      :width="300"
      :height="300"
      :url="url"
      lang-type="zh"
      @close="close"
      @crop-upload-success="cropSuccess"
    />

    <!-- 修改手机号码对话框 -->
    <el-dialog :title="title" :visible.sync="showChangeMobile" :width="dialogWidth" center>
      <el-form :model="mobileForm" :label-width="formLabelWidth" :rules="mobileRules" ref="mobileForm">
        <el-tooltip class="item" effect="light" content="第三方登录的账号初始密码：ganjiangyou2024" placement="top-start">
          <el-form-item label="登录密码" prop="password">
            <el-input type="password" v-model="mobileForm.password" auto-complete="off" placeholder="请输入登录密码"></el-input>
          </el-form-item>
        </el-tooltip>

        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="mobileForm.mobile" auto-complete="off" placeholder="请输入新的手机号码">
          </el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="checkNumber">
          <el-input v-model="mobileForm.checkNumber" auto-complete="off" placeholder="请输入验证码">
            <template slot="append">
              <el-button plain :disabled="flag" @click="changeMobileGetAuthCode" slot="suffix">{{ msg }}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangeMobile = false">取 消</el-button>
        <el-button type="primary" @click="submitChangeMobileForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改邮箱地址对话框 -->
    <el-dialog :title="title" :visible.sync="showChangeEmail" :width="dialogWidth" center>
      <el-form :model="emailForm" :label-width="formLabelWidth" :rules="emailRules" ref="emailForm">
        <el-tooltip class="item" effect="light" content="第三方登录的账号初始密码：ganjiangyou2024" placement="top-start">
          <el-form-item label="登录密码" prop="password">
            <el-input type="password" v-model="emailForm.password" auto-complete="off" placeholder="请输入登录密码"></el-input>
          </el-form-item>
        </el-tooltip>

        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="emailForm.email" auto-complete="off" placeholder="请输入新的邮箱地址">
          </el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="checkNumber">
          <el-input v-model="emailForm.checkNumber" auto-complete="off" placeholder="请输入验证码">
            <template slot="append">
              <el-button plain :disabled="flag2" @click="changeEmailGetAuthCode" slot="suffix">{{ msg2 }}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangeEmail = false">取 消</el-button>
        <el-button type="primary" @click="submitChangeEmailForm">确 定</el-button>
      </div>
    </el-dialog>

    <div>
      <router-view/>
    </div>

    <footer>
      <div class="ad-carousel-container">
        <PartnerList height="180px" speed="50"/>
      </div>
      <div class="footer-link">
        <p v-if="domain === 'www.ganjiangyou.cn'">
          © {{ currentYear }}
          <a href="https://www.ganjiangyou.cn"> &nbsp;赣江游&nbsp;</a>
          <a href="https://beian.miit.gov.cn/">{{ icp.icpNum1 }}</a>
        </p>
        <p v-if="domain === 'www.ganjiangyou.com'">
          © {{ currentYear }}
          <a href="https://www.ganjiangyou.com"> &nbsp;赣江游&nbsp;</a>
          <a href="https://beian.miit.gov.cn/">{{ icp.icpNum2 }}</a>
        </p>

        <a v-if="domain === 'www.ganjiangyou.cn'" href="https://beian.mps.gov.cn/#/query/webSearch?code=32011402011536" rel="noreferrer" target="_blank" class="gongan-link">
          <img src="@/assets/img/gongan.png" style="height: 18px; margin-right: 8px;">
          <span>{{ icp.gonganNum1 }}</span>
        </a>
        <a v-if="domain === 'www.ganjiangyou.com'" href="https://beian.mps.gov.cn/#/query/webSearch?code=32011402011703" rel="noreferrer" target="_blank" class="gongan-link">
          <img src="@/assets/img/gongan.png" style="height: 18px; margin-right: 8px;">
          <span>{{ icp.gonganNum2 }}</span>
        </a>
      </div>
    </footer>

    <div>
      <a
        href="javascript:void(0);"
        @click="returnTop"
        :class="isCdTopVisible?'cd-top cd-is-visible':'cd-top'"
      >Top</a>
    </div>
  </div>

</template>

<script>
import { EventBus } from '../utils/eventBus';
import PartnerList from "@/components/PartnerList";
import AvatarCropper from '@/components/AvatarCropper';
import { getWebConfig, getWebNavbar } from "@/api/index";
import { getAfterSalesList } from "@/api/afterSales";
import {filters} from "@/utils/filter";
import {delCookie, getCookie, setCookie} from "@/utils/cookieUtils";
import {
  addFeedback,
  authVerify,
  deleteUserAccessToken,
  editUser,
  getFeedbackList,
  updateUserPwd,
  changeMobileGetValidCode,
  doChangeMobile,
  changeEmailGetValidCode,
  doChangeEmail
} from "@/api/user";
import {
  getUserEnrollCount,
  readUserEnrollCount
} from "@/api/enroll";
import { getUserOrderList, cancelOrder, deleteOrder } from "@/api/order";
import { getUserResultList, certificate } from "@/api/result";
import LoginBox from "../components/LoginBox";
import {getListByDictTypeList} from "@/api/sysDictData"
// vuex中有mapState方法，相当于我们能够使用它的getset方法
import {mapMutations} from 'vuex';
import {timeAgo} from "../utils/webUtils";
import {getSearchModel} from "@/api/search";

export default {
  name: "index",
  components: {
    LoginBox,
    PartnerList,
    AvatarCropper
  },
  data() {
    return {
      // xss白名单配置
      options: {
        whiteList: {
          a: ['href', 'title', 'target'],
          span: ['class'],
          h1: ['class'],
          h2: ['class'],
          h3: ['class'],
          h4: ['class'],
          pre: [],
          code: ['class'],
          p: ['class']
        }
      },
      domain: '', // 当前页码的域名
      icp: {
        icpNum1: '苏ICP备2024077966号-1',
        gonganNum1: '苏公网安备32011402011536',
        icpNum2: '苏ICP备2024077966号-3',
        gonganNum2: '苏公网安备32011402011703',
      },
      searchModel: 0, // 搜索模式 0:SQL搜索、1:ES搜索、2:Solr搜索
      activeNames: ['1'], // 激活的折叠面板
      activeName: "0", // 激活的标签
      yesNoDictList: [], // 是否 字典列表
      genderDictList: [], // 性别 字典列表
      payStatusDictList: [], // 订单状态 字典列表
      afterSalesDictList: [], // 售后审核状态 字典列表
      feedbackDictList: [], // 反馈 字典列表
      imagecropperShow: false,
      imagecropperKey: 0,
      url: process.env.PICTURE_API + "/file/cropperPicture",
      webSite: process.env.VUE_GJY_WEB,
      webNavbarList: [],
      drawer: false,
      info: {},
      saveTitle: "",
      keyword: "",
      showSearch: false, //控制搜索框的弹出
      showHead: false, //控制导航栏的弹出
      isCdTopVisible: false,
      isVisible: true, //控制web端导航的隐藏和显示
      isLogin: false,
      showLogin: 2, //显示登录框
      userInfo: { // 用户信息
      },
      feedback: {}, //反馈提交
      blogLink: {}, //友链申请
      icon: false, //控制删除图标的显示
      labelWidth: "100px",
      currentPage: 1,
      pageSize: 10,
      total: 0, // 总数量
      currentPageTwo: 1,
      pageSizeTwo: 10,
      totalTwo: 0, // 总数量
      enrollList: [], // 我的报名
      afterSalesList: [], // 我的售后
      resultList: [], // 我的成绩
      feedbackList: [], // 我的反馈
      defaultAvatar: this.$SysConf.defaultAvatar, // 默认头像
      drawerSize: "45%",
      userEnrollCount: 0, // 用户已报名数
      browserFlag: 1, // 浏览器标志【默认Chrome】
      rules: {
        mobile: [
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码'},
        ],
        email: [
          {pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请输入正确的邮箱地址'},
        ],
        summary: [
          {min: 0, max: 200, message: '长度在0到200个字符'},
        ],
      },
      mobileRules: {
        mobile: [
          {required: true, message: '手机号码不能为空', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码'},
        ],
        password: [
          {required: true, message: '登录密码不能为空', trigger: 'blur'}
        ]
      },
      emailRules: {
        email: [
          {required: true, message: '邮箱地址不能为空', trigger: 'blur'},
          {pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请输入正确的邮箱'},
        ],
        password: [
          {required: true, message: '登录密码不能为空', trigger: 'blur'}
        ]
      },
      linkRules: {
        title: [
          {required: true, message: '网站名称不能为空', trigger: 'blur'},
          {min: 1, max: 10, message: '长度在1到10个字符'},
        ],
        summary: [
          {required: true, message: '简介不能为空', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在1到50个字符'},
        ],
        url: [
          {required: true, message: '网站地址不能为空', trigger: 'blur'},
          {pattern: /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/, message: '请输入有效的URL'},
        ],
        email: [
          {pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, message: '请输入正确的邮箱'},
        ],
      },
      userInfoRules: {
        oldPwd: [
          {required: true, message: '旧密码不能为空', trigger: 'blur'},
          {min: 5, max: 20, message: '密码长度在5到20个字符'},
        ],
        newPwd: [
          {required: true, message: '新密码不能为空', trigger: 'blur'},
          {min: 5, max: 20, message: '密码长度在5到20个字符'},
        ],
        newPwd2: [
          {required: true, message: '新密码不能为空', trigger: 'blur'},
          {min: 5, max: 20, message: '密码长度在5到20个字符'},
        ]
      },
      feedbackRules: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'},
          {min: 2, max: 50, message: '标题长度在2到50个字符'},
        ],
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'},
          {min: 5, max: 200, message: '内容长度在5到200个字符'},
        ]
      },
      labelPosition: "right",
      title: "",
      formLabelWidth: "80px",
      dialogWidth: "25%",
      showChangeMobile: false,
      flag: false,
      msg: '获取验证码',
      mobileForm: {
        mobile: "",
        checkNumber: "",
        password: ""
      },
      showChangeEmail: false,
      flag2: false,
      msg2: '获取验证码',
      emailForm: {
        email: "",
        checkNumber: "",
        password: ""
      },
    };
  },
  metaInfo() {
    return {
      title: this.info.title,
      link: [
        {rel: 'icon', href: this.info.logoPhoto}
      ],
      meta: [
        {
          name: "keywords",
          content: this.info.keyword,
        },
        {
          name: "content",
          content: this.info.summary,
        },
        {
          name: "description",
          content: this.info.summary,
        },
        {
          property: "site_name",
          content: this.info.name,
        },
      ],
    };
  },
  mounted() {
    var that = this;
    var offset = 300;
    var after = 0;
    window.addEventListener("scroll", function () {
      let scrollTop = document.documentElement.scrollTop; //当前的的位置
      let scrollHeight = document.documentElement.scrollHeight; //最高的位置
      if (scrollTop > offset) {
        that.isCdTopVisible = true;
      } else {
        that.isCdTopVisible = false;
      }
      if (scrollTop > after) {
        that.isVisible = false;
      } else {
        that.isVisible = true;
      }
      after = scrollTop;
    });

    // 屏幕自适应
    window.onresize = () => {
      return (() => {
        that.setSize()
      })()
    }

    EventBus.$on("enrollEvent", that.setUserEnrollCount)
    EventBus.$on("enrollEvent", that.getEnrollList)
  },
  computed: {
    enrollMsg() {
      return "您有" + this.userEnrollCount + "个订单待处理！";
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  watch: {
    $route(to, from) {
      this.getCurrentPageTitle()
    },
    // 判断登录状态位是否改变（用于控制弹框）
    '$store.state.app.loginMessage': function (newFlag, oldFlag) {
      this.showLogin = 1
    }
  },
  created() {
    // 获取当前域名
    this.domain = window.location.hostname;
    // 字典查询
    this.getDictList()
    this.getToken()
    this.getKeyword()
    this.getCurrentPageTitle()
    this.getWebConfigInfo()
    this.getWebNavbarList()
    this.setSize()
    // 获取浏览器类型
    this.getBrowser()
    this.getBlogSearchModel()
  },
  beforeDestroy() {
    console.log("组件销毁前需要解绑事件。否则会出现重复触发事件的问题");
    EventBus.$off('enrollEvent', this.setUserEnrollCount);
    EventBus.$off('enrollEvent', this.getEnrollList);
  },
  methods: {
    // 拿到vuex中的写的方法
    ...mapMutations(['setUserInfo', 'setLoginState', 'setWebConfigData']),
    // 搜索
    search: function () {
      if (this.keyword == "" || this.keyword.trim() == "") {
        this.$notify.error({
          title: '错误',
          message: "关键字不能为空",
          type: 'success',
          offset: 100
        });
        return;
      }
      this.$router.push({path: "/list", query: {keyword: this.keyword, model: this.searchModel}});
    },
    getBlogSearchModel: function () {
      getSearchModel().then(response => {
        console.log("获取搜索模式", response)
        if (response.code == this.$ECode.SUCCESS) {
          this.searchModel = response.data
        }
      })
    },
    setSize() {
      // 屏幕大于950px的时候，显示侧边栏
      let clientWidth = document.body.clientWidth
      if (clientWidth > 1360) {
        this.drawerSize = "45%";
        this.showSearch = true
      } else if (clientWidth < 1360 && clientWidth > 950) {
        this.drawerSize = "65%";
        this.showSearch = true
      } else if (clientWidth < 950 && clientWidth > 650) {
        this.drawerSize = "85%";
        this.showSearch = false;
        this.dialogWidth = "95%";
      } else {
        this.drawerSize = "95%";
        this.showSearch = false;
        this.dialogWidth = "95%"
      }
    },
    // 跳转到文章详情
    goToInfo(uid) {
      let routeData = this.$router.resolve({
        path: "/info",
        query: {uid: uid}
      });
      window.open(routeData.href, '_blank');
    },

    // 获取导航栏列表
    getWebNavbarList() {
      let params = {};
      params.isShow = 1
      getWebNavbar(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          let webNavbarList = response.data
          let newWebNavbarList = []
          for (let a = 0; a < webNavbarList.length; a++) {
            if (webNavbarList[a].isShow == 1) {
              newWebNavbarList.push(webNavbarList[a])
            }
          }
          this.webNavbarList = newWebNavbarList
          setCookie("webNavbarList", JSON.stringify(webNavbarList), 1)
        }
      })
    },

    // 获取反馈列表
    getFeedback: function () {
      let params = {}
      getFeedbackList(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.feedbackList = response.data.records;
        }
      })
    },

    // 获取我的报名列表
    getEnrollList: function () {
      let params = {}
      params.page = this.currentPage;
      params.rows = this.pageSize;
      getUserOrderList(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.enrollList = response.data.list;
          this.currentPage = response.data.pageNum;
          this.pageSize = response.data.pageSize;
          this.total = response.data.total;
        }
      })
    },

    // 获取我的售后列表
    getAfterSalesList: function () {
      let params = {}
      getAfterSalesList(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.afterSalesList = response.data;
        }
      })
    },

    // 获取我的成绩列表
    getResultList: function () {
      let params = {}
      params.page = this.currentPageTwo;
      params.rows = this.pageSizeTwo;
      getUserResultList(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.resultList = response.data.list;
          this.currentPageTwo = response.data.pageNum;
          this.pageSizeTwo = response.data.pageSize;
          this.totalTwo = response.data.total;
        }
      })
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getEnrollList();
    },
    handleCurrentChange: function(val) {
      this.currentPage = val;
      this.getEnrollList();
    },

    handleCurrentChangeTwo: function(val) {
      this.currentPageTwo = val;
      this.getResultList();
    },

    // 跳转到支付页面
    goToPayment: function(orderNo) {
      let routeData = this.$router.resolve({
        path: "/payment",
        query: {
          orderNo: orderNo
        }
      });
      window.open(routeData.href, '_self');
    },

    // 删除已取消的订单
    delOrder: function(orderNo) {
      this.$confirm("确定删除订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {}
          params.orderNo = orderNo;
          deleteOrder(params).then(response => {
            if(response.code == this.$ECode.SUCCESS) {
              this.$commonUtil.message.success(response.data)
            } else {
              this.$commonUtil.message.error(response.data)
            }
            this.getEnrollList();
          });
        })
        .catch(() => {
          this.$commonUtil.message.info("已取消删除")
        });
    },

    // 取消未支付的订单
    cancelOrder: function(orderNo) {
      this.$confirm("确定取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {}
          params.orderNo = orderNo;
          cancelOrder(params).then(response => {
            if(response.code == this.$ECode.SUCCESS) {
              this.$commonUtil.message.success(response.data)
            } else {
              this.$commonUtil.message.error(response.data)
            }
            this.getEnrollList();
          });
        })
        .catch(() => {
          this.$commonUtil.message.info("已取消操作")
        });

    },

    showDetails: function(orderNo) {
      let routeData = this.$router.resolve({
        path: "/orderdetails",
        query: {
          orderNo: orderNo
        }
      });
      window.open(routeData.href, '_self');
    },

    // 标签选择
    handleClick(tab, event) {
      switch (tab.index) {
        case "0": {
          console.log("点击个人中心")
        }
          ;
          break;
        case "1": {
          console.log("点击我的报名")
          this.getEnrollList()
          // 判断用户是否未读消息
          if (this.userEnrollCount > 0) {
            // 设置已读
            readUserEnrollCount().then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                // 阅读成功
                this.userEnrollCount = 0;
              }
            })
          }
        }
          ;
          break;
        case "2": {
          console.log("点击我的售后")
          this.getAfterSalesList()
        }
          ;
          break;
        case "3": {
          console.log("点击我的成绩")
          this.getResultList()
        }
          ;
          break;
        case "4": {
          console.log("点击我的反馈")
          this.getFeedback()
        }
          ;
          break;
        case "5": {
          console.log("点击修改密码")
        }
          ;
          break;
      }
    },
    changeMobileGetAuthCode () {
      this.$refs['mobileForm'].validate(async (valid) => {
        if (valid) {
          const that = this
          that.flag = true
          var time = 60
          var timer = null
          timer = setInterval(function () {
            if (time === 0) {
              that.msg = '重新获取验证码'
              that.flag = false
              clearInterval(timer)
            } else {
              that.msg = time + '秒后重新获取'
              time--
            }
          }, 1000)
          let params = new URLSearchParams()
          params.append("mobile", that.mobileForm.mobile)
          changeMobileGetValidCode(params).then(response => {
            if (response.code != this.$ECode.SUCCESS) {
              this.$message({
                type: "error",
                message: response.data,
                offset: 100
              })
              clearInterval(timer);
              that.flag = false;
            }
          })
        }
      })
    },
    // 弹出选择图片框
    checkPhoto() {
      this.imagecropperShow = true
    },
    // 修改手机号码
    changeMobile() {
      this.showChangeMobile = true
      this.title = "修改手机号码"
    },
    // 修改手机号码，确定
    submitChangeMobileForm() {
      this.$refs.mobileForm.validate((valid) => {
        if(!valid) {
          console.log('校验失败')
          return;
        } else {
          if(this.mobileForm.checkNumber == "") {
            this.$message.warning('验证码不能为空')
            return;
          }
          let params = {};
          params.mobile = this.mobileForm.mobile;
          params.password = this.mobileForm.password;
          params.code = this.mobileForm.checkNumber;
          doChangeMobile(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data
              })
              this.mobileForm.mobile = '';
              this.mobileForm.password = '';
              this.mobileForm.checkNumber = '';
              this.showChangeMobile = false;
              this.getToken();
            } else {
              this.$message({
                type: "error",
                message: response.data
              })
            }
          });
        }
      })
    },
    // 修改邮箱地址
    changeEmail() {
      this.showChangeEmail = true
      this.title = "修改邮箱地址"
    },
    changeEmailGetAuthCode () {
      this.$refs['emailForm'].validate(async (valid) => {
        if (valid) {
          const that = this
          that.flag2 = true
          var time = 60
          var timer = null
          timer = setInterval(function () {
            if (time === 0) {
              that.msg2 = '重新获取验证码'
              that.flag2 = false
              clearInterval(timer)
            } else {
              that.msg2 = time + '秒后重新获取'
              time--
            }
          }, 1000)
          let params = new URLSearchParams()
          params.append("email", that.emailForm.email)
          changeEmailGetValidCode(params).then(response => {
            if (response.code != this.$ECode.SUCCESS) {
              this.$message({
                type: "error",
                message: response.data,
                offset: 100
              })
              clearInterval(timer);
              that.flag2 = false;
            }
          })
        }
      })
    },

    // 修改邮箱地址，确定
    submitChangeEmailForm() {
      this.$refs.emailForm.validate((valid) => {
        if(!valid) {
          console.log('校验失败')
          return;
        } else {
          if(this.emailForm.checkNumber == "") {
            this.$message.warning('验证码不能为空')
            return;
          }
          let params = {};
          params.email = this.emailForm.email;
          params.password = this.emailForm.password;
          params.code = this.emailForm.checkNumber;
          doChangeEmail(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data
              })
              this.emailForm.email = '';
              this.emailForm.password = '';
              this.emailForm.checkNumber = '';
              this.showChangeEmail = false;
              this.getToken();
            } else {
              this.$message({
                type: "error",
                message: response.data
              })
            }
          });
        }
      })
    },

    /**
     * dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
     * @param dateTimeStamp
     * @returns {string}
     */
    timeAgo(dateTimeStamp) {
      return timeAgo(dateTimeStamp)
    },

    cropSuccess(resData) {
      this.imagecropperShow = false
      this.imagecropperKey = this.imagecropperKey + 1
      // 判断当前激活的页面
      if (this.activeName == "0") {
        // 激活个人中心页面
        this.userInfo.photoUrl = resData[0].url
        this.userInfo.avatar = resData[0].uid
      } else if (this.activeName == "5") {
        let photoList = []
        photoList.push(resData[0].url);
        this.blogLink.photoList = photoList
        this.blogLink.fileUid = resData[0].uid
      }
    },

    deletePhoto: function (type) {
      switch (type) {
        case "user": {
          this.userInfo.photoUrl = null;
          this.userInfo.avatar = "";
          this.icon = false;
        }
          break;

        case "link": {
          this.blogLink.photoList = null;
          this.icon = false;
        }
          break;
      }
    },

    close() {
      this.imagecropperShow = false
    },

    submitForm: function (type) {
      switch (type) {
        case "editUser": {
          this.$refs.userInfo.validate((valid) => {
            if (!valid) {
              console.log("校验失败")
            } else {
              editUser(this.userInfo).then(response => {
                if (response.code == this.$ECode.SUCCESS) {
                  this.$message({
                    type: "success",
                    message: response.data
                  })
                } else {
                  this.$message({
                    type: "error",
                    message: response.data
                  })
                }
              });
            }
          })
        }
          ;
          break;

        case "feedback": {
          this.$refs.feedback.validate((valid) => {
            if (!valid) {
              console.log("校验失败")
            } else {
              addFeedback(this.feedback).then(response => {
                if (response.code == this.$ECode.SUCCESS) {
                  this.$message({
                    type: "success",
                    message: response.data
                  })
                  this.feedback = {}
                  this.getFeedback()
                } else {
                  this.$message({
                    type: "error",
                    message: response.data
                  })
                }
                // 重置表单
                this.$refs.feedback.resetFields()
              });
            }
          });
        }
          ;
          break;

        case "changePwd": {
          let newPwd = this.userInfo.newPwd
          let newPwd2 = this.userInfo.newPwd2
          let oldPwd = this.userInfo.oldPwd
          if (newPwd != newPwd2) {
            this.$message({
              type: "error",
              message: "两次密码不一致"
            })
            return
          }
          if (newPwd == oldPwd) {
            this.$message({
              type: "error",
              message: "新旧密码相同"
            })
            return
          }
          let params = new URLSearchParams()
          params.append("oldPwd", oldPwd)
          params.append("newPwd", newPwd)
          updateUserPwd(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data
              })
            } else {
              this.$message({
                type: "error",
                message: response.data
              })
            }
            // 重置表单
            this.$refs.userInfoForm.resetFields()
          })
        }
          ;
          break;
      }
    },
    /**
     * 字典查询
     */
    getDictList: function () {
      let dictTypeList = ['sys_yes_no', 'sys_user_sex', 'sys_pay_status', 'sys_audit_status', 'sys_feedback_status']

      getListByDictTypeList(dictTypeList).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          let dictMap = response.data;
          this.genderDictList = dictMap.sys_user_sex.list;
          this.payStatusDictList = dictMap.sys_pay_status.list;
          this.yesNoDictList = dictMap.sys_yes_no.list;
          this.afterSalesDictList = dictMap.sys_audit_status.list;
          this.feedbackDictList = dictMap.sys_feedback_status.list;
        }
      });
    },

    getToken: function () {
      let token = this.getUrlVars()["token"];
      // 判断url中是否含有token
      if (token) {
        // 设置token七天过期
        setCookie("token", token, 7)
      } else {
        // 从cookie中获取token
        token = getCookie("token")
      }
      if (token) {
        authVerify(token).then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            this.isLogin = true;
            this.userInfo = response.data;
            this.setUserInfo(this.userInfo);
            // 获取用户的报名数
            this.setUserEnrollCount()
          } else {
            this.isLogin = false;
            delCookie("token");
          }
          this.setLoginState(this.isLogin);
          // 获取原页面地址，登录后进行跳转到原页面，如果为空或者就是在首页登录，不进行跳转
          const redirectUrl = getCookie("redirectUrl");
          if (redirectUrl != undefined && redirectUrl != "" && redirectUrl != "/") {
            window.location.href = redirectUrl;
            // 清除缓存的原页面地址
            delCookie("redirectUrl");
            return;
          }
          // 获取当前URL
          const currentURL = window.location.href;
          // 使用正则表达式匹配URL中的token参数
          const tokenRegex = /token=([^&]*)/;
          const tokenMatch = currentURL.match(tokenRegex);
          // 如果token存在，去除它
          if (tokenMatch) {
            // 去除token后的URL
            const newURL = currentURL.replace(tokenRegex, '');
            // 用新的URL替换浏览器地址
            window.location.href = newURL;
          }
        });
      } else {
        this.isLogin = false;
        this.setLoginState(this.isLogin);
      }
    },
    setUserEnrollCount: function () {
      getUserEnrollCount().then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.userEnrollCount = response.data
        }
      });
    },
    getKeyword: function () {
      let tempValue = decodeURI(this.getUrlVars()["keyword"]);
      if (
        tempValue == null ||
        tempValue == undefined ||
        tempValue == "undefined"
      ) {
      } else {
        this.keyword = tempValue;
      }
    },
    /**
     * 获取当前所在页面的标题
     * @returns {{}}
     */
    getCurrentPageTitle: function () {
      let test = window.location.href;
      let start = 0;
      let end = test.length;
      for (let i = 0; i < test.length; i++) {
        if (test[i] == "#") {
          start = i;
        }
        if (test[i] == "?" && i > start) {
          end = i;
        }
      }
      let result = test.substring(start + 1, end);
      this.saveTitle = result;
    },
    /**
     * 获取网站配置
     */
    getWebConfigInfo: function () {
      let webConfigData = this.$store.state.app.webConfigData
      if (webConfigData.createTime) {

      } else {
        getWebConfig().then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            this.info = response.data;
            // 存储在Vuex中
            this.setWebConfigData(response.data)
          }
        });
      }
    },
    /**
     * 截取URL中的参数
     * @returns {{}}
     */
    getUrlVars: function () {
      var vars = {};
      var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&#]*)/gi,
        function (m, key, value) {
          vars[key] = value;
        }
      );
      return vars;
    },
    clickSearchIco: function () {
      if (this.keyword != "") {
        this.search();
      }
      this.showSearch = !this.showSearch;
      //获取焦点
      this.$refs.searchInput.focus();
    },
    openHead: function () {
      this.showHead = !this.showHead;
    },
    returnTop: function () {
      window.scrollTo(0, 0);
    },
    userLogin: function () {
      this.showLogin = 1;
    },
    userLogout: function () {
      deleteUserAccessToken(getCookie("token"));
      delCookie("token");
      delCookie("source");
      let url = window.parent.location.href;
      let haveToken = url.indexOf("?token")
      if (haveToken != -1) {
        let list = url.split("?token");
        this.isLogin = false;
        window.location.href = list[0]
        let userInfo = {};
        this.setUserInfo(userInfo)
      } else {
        window.location.reload()
      }
    },

    // 点击头像触发的动作
    handleCommand(command) {
      switch (command) {
        case "logout" : {
          this.userLogout();
        }
          ;
          break;
        case "login" : {
          this.userLogin();
        }
          ;
          break;
        case "goUserInfo" : {
          // 打开抽屉
          this.drawer = true;
        }
          break;
      }
    },
    closeLoginBox: function () {
      this.showLogin = 2;
    },
    // 获取浏览器类型
    getBrowser() {
      let sBrowser, sUsrAg = navigator.userAgent;
      if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
        this.browserFlag = 2;
        // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
      } else if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome or Chromium";
        this.browserFlag = 1;
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
      }

    },
    downloadCertificate(raceResultId) {
      let params = {};
      params.raceResultId = raceResultId;
      certificate(params).then(response => {
        if(!response) {
          return;
        }
        let link = document.createElement('a'); // 创建a标签
        link.style.display = 'none'; // 隐藏标签
        link.href = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        link.target = '_blank';
        const fileName = '证书.pdf';
        link.download = decodeURIComponent(fileName);
        document.body.appendChild(link);
        link.click()
        URL.revokeObjectURL(link.href); // 释放内存
        document.body.removeChild(link); // 移除a标签
      });
    }
  }
};
</script>

<style>
@import "../assets/css/emoji.css";

.emoji-panel-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.emoji-item-common {
  background: url("../assets/img/emoji_sprite.png");
  display: inline-block;
  zoom: 0.3;
}

.emoji-item-common:hover {
  cursor: pointer;
}

.emoji-size-small {
  zoom: 0.3;
}
</style>

<style scoped>
.el-tag {
  height: 25px;
  line-height: 25px;
  margin-left: 6px;
}

#starlist li .title {
  color: #00a7eb;
}

.userInfoAvatar {
  width: 35px;
  height: 35px;
  position: absolute;
  right: -77px;
}

.userInfoAvatar img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

@media only screen and (max-width: 1300px) {
  .userInfoAvatar {
    width: 35px;
    height: 35px;
    position: absolute;
    right: 10px;
    top: 0px;
  }

  .searchbox {
    position: absolute;
    right: 50px;
    top: 0
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 0, 0, 0, 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.imgBody {
  width: 100px;
  height: 100px;
  border: solid 2px #ffffff;
  float: left;
  position: relative;
}

.imgBody img {
  width: 100px;
  height: 100px;
}

.uploadImgBody {
  margin-left: 5px;
  width: 100px;
  height: 100px;
  border: dashed 1px #c0c0c0;
  float: left;
  position: relative;
}

.uploadImgBody :hover {
  border: dashed 1px #00ccff;
}

.inputClass {
  position: absolute;
}

.commentList {
  width: 100%;
  margin: 0 auto;
}

.commentList .p1 {
  float: left;
}

.commentList .left {
  display: inline-block;
  width: 10%;
  height: 100%;
}

.commentList .left img {
  margin: 0 auto;
  width: 100%;
  border-radius: 50%;
}

.commentList .right {
  display: inline-block;
  width: 85%;
  margin-left: 5px;
}

.commentList .rightTop {
  height: 30px;
}

.commentList .rightTop .userName {
  color: #303133;
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
}

.commentList .rightTop .timeAgo {
  color: #909399;
  margin-left: 10px;
  font-size: 15px;
}

.commentList .rightCenter {
  margin-left: 20px;
  line-height: 30px;
  min-height: 60px;
}

.commentList .rightBottom el-link {

}

.afterSalesCard .item .title {
  display: inline-block;
  width: 70px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
}

.afterSalesCard .item .order {
  display: inline-block;
  width: 240px;
  margin-bottom: 5px;
  cursor: pointer;
  color: #409eff;
  text-decoration: underline;
}

.afterSalesCard .item .content {
  display: inline-block;
  width: 240px;
  margin-bottom: 5px;
}

.feedbackCard .item .title {
  display: inline-block;
  width: 70px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
}

.feedbackCard .item .content {
  display: inline-block;
  width: 240px;
  margin-bottom: 5px;
}

.search_ico2 {
  width: 60px;
  height: 60px;
  display: block;
  position: absolute;
  right: 0;
  top: 15px;
  padding: 0;
  margin: 0;
  line-height: 60px;
  cursor: pointer;
}

.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue